/* eslint-disable */
import React, { useEffect, useState } from 'react';
import {
    Table, Button, Header, Modal
} from 'semantic-ui-react';
import Dayjs from 'dayjs';
import Swal from '#/swal';
import { connect } from 'react-redux';
import { actions } from './sagaSlice';
import Form from './Form';
import SigForm from './sigForm';

const NotaryList = props => {

    const { readAll, notaries } = props;

    const [modalOpen, setModalOpen] = useState(false);
    const [sigModalOpen, setSigModalOpen] = useState(false);
    const [initialValues, setInitialValues] = useState(null);

    const onSubmit = async values => {

        initialValues ? await props.update(values) : await props.create(values);
        setModalOpen(false);
    };


    const handleDelete = async ({ name, id }) => {
        const { value } = await Swal.fire.warning({ text: `This will delete ${name}.` });

        if (value) props.delete(id);
    };

    useEffect(readAll, [readAll]);

    return (
        <div style={styles.root}>
            <div style={styles.header}>
                <div>
                    <Header
                        as='h2'
                        content='Notaries'
                        color='grey'
                    />
                </div>

                <div>
                    <Button
                        compact
                        primary
                        icon='add'
                        content='New Notary'
                        onClick={() => {
                            setInitialValues(null);
                            setModalOpen(true);
                        }}
                    />
                </div>
            </div>
            <Table celled compact singleLine>
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell content='Name'/>
                        <Table.HeaderCell content='Commission #'/>
                        <Table.HeaderCell content='Commission Expiration'/>
                        <Table.HeaderCell collapsing textAlign='center' content='Actions'/>
                    </Table.Row>
                </Table.Header>

                <Table.Body>
                    {
                        notaries
                    && notaries.map((notary, i) => (
                        <Table.Row key={i}>
                            <Table.Cell content={notary.name}/>
                            <Table.Cell content={notary.commission_number}/>
                            <Table.Cell content={Dayjs(notary.commission_expiration).format('MM/DD/YYYY')}/>
                            <Table.Cell collapsing>

                                <Button
                                    compact
                                    size='small'
                                    icon='edit'
                                    onClick={() => {
                                        setInitialValues({
                                            ...notary,
                                            commission_expiration: notary.commission_expiration.split('T')[0]
                                        });
                                        setModalOpen(true);
                                    }}
                                    content='Edit'
                                />
                                <Button
                                    compact
                                    size='small'
                                    icon='edit'
                                    onClick={() => {
                                        setInitialValues({
                                            ...notary,
                                            commission_expiration: notary.commission_expiration.split('T')[0]
                                        });
                                        setSigModalOpen(true);
                                    }}
                                    content='add stamp'
                                />
                                <Button
                                    compact
                                    size='small'
                                    color='red'
                                    icon='delete'
                                    onClick={() => handleDelete(notary)}
                                    content='Delete'
                                />

                            </Table.Cell>
                        </Table.Row>
                    ))
                    }
                </Table.Body>

            </Table>

            <Modal
                open={modalOpen}
                size='tiny'>
                <Modal.Content>
                    <Form onSubmit={onSubmit} setModalOpen={setModalOpen} initialValues={initialValues}/>
                </Modal.Content>
            </Modal>

            <Modal
                open={sigModalOpen}
                size='tiny'>

                <Modal.Content>
                    <SigForm setModalOpen={setSigModalOpen} initialValues={initialValues}/>
                </Modal.Content>
            </Modal>

        </div>
    );
};

const styles = {
    root: { margin: '10px' },
    header: {
        display: 'flex',
        justifyContent: 'space-between',
        margin: '10px',
        alignItems: 'center',
        paddingTop: '20px'
    }
};

const mapStateToProps = state => ({ notaries: Object.values(state.notaries.data) });

export default connect(mapStateToProps, actions)(NotaryList);
